import { FormattedMessage } from 'react-intl';

import './VideoDescription.css';

interface VideoDescriptionProps {
	text: string;
	onViewDetails?: () => void;
}

export default function VideoDescription({ text, onViewDetails }: VideoDescriptionProps) {
	return (
		<section title={text} id="video-description">
			<h3>
				<span>
					<FormattedMessage id="sentinel.video-description.title" />
				</span>

				<button onClick={onViewDetails}>
					<FormattedMessage id="view-all" />
				</button>
			</h3>
			<p className="truncate">{text}</p>
		</section>
	);
}
